// eslint-disable-next-line import/prefer-default-export
export { default as ContactSearchProfileCardWithFragment } from './contact-search-profile-card-with-fragment';
